export default {
    setToken: token => {
        sessionStorage.setItem("token", token);
    },
    getToken: () => {
        return sessionStorage.getItem("token");
    },
    removeToken: () => {
        sessionStorage.removeItem("token");
    },
    setId: id => {
        sessionStorage.setItem("id", id);
    },
    getId: () => {
        return sessionStorage.getItem("id");
    },
    removeId: () => {
        sessionStorage.removeItem("id");
    },
    setName: name => {
        sessionStorage.setItem("name", name);
    },
    getName: () => {
        return sessionStorage.getItem("name");
    },
    removeName: () => {
        sessionStorage.removeItem("name");
    },
    setAreas: areas => {
        sessionStorage.setItem("areas", JSON.stringify(areas));
    },
    getAreas: () => {
        return JSON.parse(sessionStorage.getItem("areas"));
    },
    removeAreas: () => {
        sessionStorage.removeItem("areas");
    },
    setTags: tags => {
        let tagsString = JSON.stringify(tags)
        
        sessionStorage.setItem("tags", tagsString);
    },
    getTags: type => {
        let tags = JSON.parse(sessionStorage.getItem("tags"));

        return tags[type]
    },
    removeTags: () => {
        sessionStorage.removeItem("tags");
    },
    setFilters: filters => {
        let filtersString = JSON.stringify(filters)
        
        sessionStorage.setItem("filters", filtersString);
    },
    getFilters: type => {
        let filters = JSON.parse(sessionStorage.getItem("filters"));

        return filters[type]
    },
    removeFilters: () => {
        sessionStorage.removeItem("filters");
    },
    setFiltersJson: filtersJson => {
        let filtersJsonString = JSON.stringify(filtersJson)
        
        sessionStorage.setItem("filtersJson", filtersJsonString);
    },
    getFiltersJson: type => {
        let filtersJson = JSON.parse(sessionStorage.getItem("filtersJson"));

        return filtersJson[type]
    },
    removeFiltersJson: () => {
        sessionStorage.removeItem("filtersJson");
    }
};



// WEBPACK FOOTER //
// ./src/common/storage.js